/**
 * What's New endpoints — the login-time popup + its admin management.
 *
 * Talks to apps/api routes/whats-new.ts. `status`/`acknowledge` are scoped to
 * the caller's own dismissal state (no id ever passed); managing the
 * announcement list requires an admin token (enforced server-side).
 */

import { apiGet, apiPost, apiPut, apiDelete } from '../client.js';

/** @returns {Promise<{ ok: boolean, shouldShow: boolean, entries: any[] }>} */
export const getWhatsNewStatus = () => apiGet('/api/whats-new/status');

/** @param {boolean} dontShowAgain */
export const acknowledgeWhatsNew = (dontShowAgain) =>
  apiPost('/api/whats-new/acknowledge', { body: { dontShowAgain: !!dontShowAgain } });

/** Admin: every announcement, newest first. */
export const getWhatsNewEntries = () => apiGet('/api/whats-new/entries');

/** Admin: create/update an announcement (no id = create). */
export const saveWhatsNewEntry = (entry) =>
  entry.id
    ? apiPut(`/api/whats-new/entries/${encodeURIComponent(entry.id)}`, { body: entry })
    : apiPost('/api/whats-new/entries', { body: entry });

/** Admin: delete an announcement. */
export const deleteWhatsNewEntry = (id) => apiDelete(`/api/whats-new/entries/${encodeURIComponent(id)}`);
